<template lang="pug">
section
  div
    | If the Home Office visits you,
    | they will judge you against
    | the following criteria:

  br

  ul
    li
      b HR Systems
      | :
      | whether you have the systems
      | in place to monitor the attendance
      | of the sponsored migrant,
      | or to identify when their current leave
      | is coming to an end;
    li
      b Migrant Compliance
      | :
      | whether you are employing any workers
      | (sponsored or not),
      | who are in breach of the conditions
      | of their immigration permission
      | –
      | for example, a Student
      | who is working more hours
      | than they are allowed to;
    li
      b Convictions and civil penalties
      | :
      | whether or not you have
      | any unspent criminal convictions
      | or have been issued with a civil penalty;
    li
      b Employment
      | :
      | whether you can offer employment
      | which meets the criteria
      | for the relevant immigration route
      | (such as genuine vacancy,
      | salary and skill-level).

  br

  div
    | If you are not able to satisfy
    | all of these criteria,
    | your application will be refused.
</template>

<script>
export default {
  name: "decision_scoring_system",
};
</script>